import React from 'react';
import { Alert, AlertTitle, Box, useTheme } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ErrorNotification = ({ error, ml, mr, mt, mb }) => {
    const theme = useTheme();
    
    if (!error) return null;

    return (
        <Box sx={{ ml, mr, mt, mb }}>
            <Alert 
                severity="error"
                icon={<ErrorOutlineIcon />}
                sx={{
                    borderRadius: 2,
                    boxShadow: theme.shadows[2],
                    '& .MuiAlert-icon': {
                        fontSize: 28,
                    },
                }}
            >
                {error.errorCode && (
                    <AlertTitle sx={{ fontWeight: 600, mb: 0.5 }}>
                        Σφάλμα {error.errorCode}
                    </AlertTitle>
                )}
                {error.message || error.response?.data?.message || 'Προέκυψε ένα σφάλμα'}
            </Alert>
        </Box>
    );
};

export default ErrorNotification;